export default "__VITE_ASSET__CEsevhoJ__"